module["exports"] = [
  "### ###-####",
  "1 ### ###-####",
  "### ###-####, poste ###"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fr_CA/phone_number/formats.js
// module id = 1591
// module chunks = 1